import { useNavigationTree, useNavigationState } from '@/shared/lib';

const NAVIGATION_STATE_KEY = 'navigation_state';
const DOCUMENT_CACHE_KEY = 'document_cache';

export function useHomeNavigationReset(clearDocumentCache: () => void) {
  const { reset } = useNavigationTree({ useGlobalState: true });
  const { clearAllState } = useNavigationState(false);

  function clearNavigationState(clearFilters?: () => void) {
    reset();
    clearAllState();
    localStorage.removeItem(NAVIGATION_STATE_KEY);
    localStorage.removeItem(DOCUMENT_CACHE_KEY);
    clearFilters?.();
    clearDocumentCache();
  }

  return { clearNavigationState };
}
